<template>
  <div style="flex: 1">
    <div style="flex: 1">
      <div class="uploadHeader">
        <h2 class="uploadHeaderTitle">身份证上传</h2>
        <span class="uploadHeaderText">支持上传jpg、jpeg、png格式的图片</span>
      </div>
      <div class="uploadBody">
        <div class="uploadBodyIdCard">
          <el-upload
            class="avatar-uploader"
            :headers="headers"
            action=""
            accept=".jpg,.png,.jpeg"
            ref="userIdCardFrontRef"
            :show-file-list="false"
            :before-upload="
              e =>
                handleBeforeUpload(e, {
                  name: 'userIdCardFront'
                })
            "
          >
            <div class="upload-image">
              <el-image v-if="uploadedIdCard?.userIdCardFront?.base64" :src="uploadedIdCard?.userIdCardFront?.base64" class="idacard-icon"></el-image>
              <el-image v-else :src="require('@/assets/images/idcard-frontend.png')" class="idacard-icon"></el-image>
              <UploadAsideLine />
            </div>
            <div style="margin-top: 20px">请上传身份证人像面</div>
          </el-upload>
          <el-upload
            class="avatar-uploader"
            :headers="headers"
            action=""
            accept=".jpg,.png,.jpeg"
            ref="userIdCardBackRef"
            :show-file-list="false"
            :before-upload="
              e =>
                handleBeforeUpload(e, {
                  name: 'userIdCardBack'
                })
            "
          >
            <div class="upload-image">
              <el-image v-if="uploadedIdCard?.userIdCardBack?.base64" :src="uploadedIdCard?.userIdCardBack?.base64" class="idacard-icon"></el-image>
              <el-image v-else :src="require('@/assets/images/idcard-backend.png')" class="idacard-icon"></el-image>
              <UploadAsideLine />
            </div>
            <div style="margin-top: 20px">请上传身份证国徽面</div>
          </el-upload>
        </div>
      </div>
      <div class="uploadBottom">
        <el-button type="primary" :disabled="Object.keys(uploadedIdCard).length < 2" @click="handleIdCardIdentity">证件识别</el-button>
      </div>
    </div>
    <ImageCropperDialog v-if="imageCropperVisible" :options="imageCropperOptions" @cropperFile="handleCropperFile" @close="imageCropperVisible = false" />
  </div>
</template>
<script setup>
import { onMounted, ref,getCurrentInstance } from 'vue'
import { getToken } from '@/utils/auth'
import UploadAsideLine from './UploadAsideLine.vue'
import ImageCropperDialog from '@/components/ImageCropperDialog.vue'
import { useFileSystem, useFileTypeConvert } from '@/hooks'
import { identifyIdCardInfo } from '@/modules/personalCenter/api/personalCenter'
import { debounce } from 'lodash-es'
import { Loading, Message } from 'element-ui'
import store from "../../../../store";
const { imageUpload } = useFileSystem()
const { base64ToFile } = useFileTypeConvert()

const { ctx: _this } = getCurrentInstance()


const headers = {
  Authorization: getToken()
}

const emits = defineEmits(['identity'])

const imageCropperVisible = ref(false)
const imageCropperOptions = ref({})
const uploadedIdCard = ref({})
const userIdCardFrontRef = ref(null)
const userIdCardBackRef = ref(null)

const handleBeforeUpload = async (rawFile, option = {}) => {
  const exts = ['jpg', 'jpeg', 'png']
  let curExt = rawFile.name.slice(rawFile.name.lastIndexOf('.') + 1)
  if (!exts.includes(curExt)) {

    Message.error('请上传' + exts.join('、') + '的文件')
    return false
  }

  imageCropperVisible.value = true

  const reader = new FileReader()
  reader.readAsDataURL(rawFile)
  reader.onload = () => {
    imageCropperOptions.value = {
      img: reader.result, //裁剪图片的地址
      autoCrop: true, // 是否默认生成截图框
      autoCropWidth: 320, // 默认生成截图框宽度
      autoCropHeight: 200, // 默认生成截图框高度
      fixedBox: true, // 固定截图框大小 不允许改变
      ...option
    }
  }

  return false
  return Promise.resolve()
}

const handleCropperFile = async (file, options) => {
  const res = await imageUpload(base64ToFile(file))
  Object.assign(uploadedIdCard.value, {
    [options.name]: {
      ...res,
      base64: file
    }
  })
  imageCropperVisible.value = false
}

const handleIdCardIdentity = debounce(async function () {
  console.log('证件识别..........')
  const loading = Loading.service({
    lock: true,
    text: '正在识别中',
    spinner: 'el-icon-loading',
    background: 'rgba(0, 0, 0, 0.7)'
  })
  const res = await identifyIdCardInfo({
    idCardIconBase64: uploadedIdCard.value.userIdCardFront.base64.replace('data:image/jpeg;base64,', '').replace('data:image/png;base64,', '').replace('data:image/jpg;base64,', '')
  })
    .catch(() => {})
    .finally(() => {
      loading.close()
    })

  const parseRes =  JSON.parse(res)
  const {identityNum} = JSON.parse(localStorage.getItem('fstat'))

  if(identityNum && identityNum!==parseRes['公民身份号码'].words){
    window.$vm.$message({
      showClose: true,
      message: '识别身份证号与系统导入证件不一致，请联系管理员',
      type: 'warning'
    })
    return
  }

  emits('identity', {
    identityInfo: JSON.parse(res),
    ...uploadedIdCard.value
  })
}, 500)
</script>

<style scoped lang="scss">
.uploadHeader {
  display: flex;
  align-items: center;
  .uploadHeaderTitle {
    margin-bottom: 0;
    margin-top: 0;
  }
  .uploadHeaderText {
    color: #f66767;
    font-size: 13px;
    margin-left: 10px;
  }
}
.uploadBody {
  margin-top: 105px;
  .uploadBodyIdCard {
    display: flex;
    justify-content: center;
    align-items: center;
    > div {
      &:last-child {
        margin-left: 84px;
      }
    }
    .upload-image {
      position: relative;
      .idacard-icon {
        width: 320px;
        height: 200px;
      }
    }
    :deep(.el-upload){
      border:0!important;
    }
  }
}
.uploadBottom {
  width: 300px;
  height: 60px;
  margin: 80px auto 0;
  .el-button {
    width: 100%;
    border-radius: 20px;
  }
}
</style>
